<template>
  <div id="material-template-page">
    <div class="material-content">
      <div
        class="view-pdf"
        v-if="
          material.url &&
          (material.url.indexOf('pdf') > -1 || material.url.indexOf('doc') > -1)
        "
      >
        <iframe
          v-if="material.url"
          :src="material.url"
          frameborder="0"
        ></iframe>
      </div>

      <div
        v-if="
          material.url &&
          material.url.indexOf('doc') < 0 &&
          material.url.indexOf('pdf') < 0
        "
      >
        <img :src="material.url" />
      </div>
    </div>
  </div>
</template>

<script>
import ProductService from '../services/productService.js';

export default {
  name: 'materialTemplate',
  data() {
    return {
      productService: new ProductService(this.$http),
      material: {
        name: '',
        url: '',
      },
    };
  },
  mounted() {
    this.cleanBodyTop();
    this.parseUrlParam();
  },
  methods: {
    parseUrlParam() {
      this.material = {
        name: decodeURIComponent(this.productService.getParamByName('name')),
        url: decodeURIComponent(this.productService.getParamByName('url')),
      };

      document.title = this.material.name;
    },
    cleanBodyTop() {
      const body = document.body;
      body.style.position = 'static';
    },
  },
};
</script>

<style lang="less" scoped>
#material-template-page {
  height: 100%;
  background-color: #fff;
  width: 100%;
  .material-content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 0.16rem;
    }
    img {
      max-width: 100%;
    }
    .view-pdf {
      height: 100%;
      width: 100%;
      iframe {
        height: 100%;
        width: 100%;
      }
    }
  }
  .footer {
    height: 52px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    padding: 0.05rem;
    button {
      display: block;
      background-color: #ff5a60;
      color: #fff;
      font-size: 0.16rem;
      text-align: center;
      width: 100%;
      height: 100%;
      border-width: 0;
      border-radius: 0.03rem;
    }
  }
}
</style>
